<ngx-spinner type="ball-atom"></ngx-spinner>
<div class="component-container">
  <div class="component-header">
    <h2>Audit Fee Categories</h2>
    <div class="button-group">
      <button mat-raised-button color="primary" (click)="onCreateAuditFeeCategory()">
        <mat-icon>add</mat-icon>
        Add Audit Fee Category
      </button>
    </div>
  </div>
  <app-lookup-table
      [items]="auditFeeCategories()"
      [columns]="auditFeeCategoriesColumns"
      (itemClick)="onItemSelected($event)"
      (editClick)="onEditAuditFeeCategory($event)"
      (deleteClick)="onDeleteAuditFeeCategory($event)"
      (itemSave)="onItemSave($event)"
      (itemAdd)="onItemAdd($event)">
    </app-lookup-table>
</div>
